import { TAvatar, voices } from '@common';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type TFormState = TAvatar & { _id?: string };
const initialState: TFormState = {
  prompt: "",
  behavior: '',
  scene: 'metahumans/white',
  language: 'ru-RU',
  name: '',
  voice: '',
  ttsEngine: '',
  type: '',
  greeting: 'Привет! Подскажу, помогу разобраться, сориентирую. Что вы хотите узнать?',
  logo: '',
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    changeFormData: (state, action: PayloadAction<Partial<TFormState>>) => ({
      ...state,
      ...action.payload,
    }),
    resetFormData: () => initialState,
  },
});

export const { changeFormData, resetFormData } = formSlice.actions;
export const formReducer = formSlice.reducer;
